import { isPrivateView } from '@/common/components/FilterViews/helpers'

const getFirstSharedView = customViews => customViews.find(view => !isPrivateView(view))

const getFirstPrivateView = customViews => customViews.find(isPrivateView)

export const getDefaultView = (customViews, defaultViews, selectedViewId) => {
  const preselectedCustomView = customViews.find(view => view.id === selectedViewId)
  const preselectedDefaultView = defaultViews.find(view => view.id === selectedViewId)
  const defaultView = defaultViews.find(view => view.id === 'default')

  return (
    preselectedCustomView ||
    preselectedDefaultView ||
    defaultView ||
    getFirstSharedView(customViews) ||
    getFirstPrivateView(customViews) ||
    null
  )
}
